import personFallingIcon from '@/assets/person-falling.svg?url';

export const STATIC_WIDGETS = Object.freeze({
  'patient-card': 'Patient Card',
  'patient-events': 'Patient Events',
  'live-video': 'Live Video'
});
export const TIMEZONES = Object.freeze([
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'UTC',
])
export const NAMED_COLORS = Object.freeze([
  'orange', 'yellow', 'green',
  'turquoise', 'cyan', 'blue',
  'purple', 'red', 'white', 'black'
])

export const LABEL_TYPES = Object.freeze({
  'FACE': 'face',
  'BED': 'bed',
  'PHI': 'phi',
  'PERSON': 'person',
  'CHAIR': 'chair',
  'LINE': 'line',
  'OBJECT': 'object',
  'POLYGON': 'polygon',
})
export const INFERENCE_TO_LABEL_TYPES = Object.freeze({
  'bed': LABEL_TYPES.BED,
  'chair': LABEL_TYPES.CHAIR,
  'faces': LABEL_TYPES.FACE,
  'person': LABEL_TYPES.PERSON,
  'polygon': LABEL_TYPES.POLYGON
})

export const LABEL_COLORS = Object.freeze({
  [LABEL_TYPES.FACE]: 'green',
  [LABEL_TYPES.BED]: 'blue',
  [LABEL_TYPES.PHI]: 'red',
  [LABEL_TYPES.PERSON]: 'purple',
  [LABEL_TYPES.CHAIR]: 'pink',
  [LABEL_TYPES.LINE]: 'aquamarine',
  [LABEL_TYPES.OBJECT]: 'black',
  [LABEL_TYPES.POLYGON]: 'orange',
})

const PRECAUTION_KEYS = Object.freeze({
  'FALL_RISK': 'fall_risk',
  'CONTACT_PRECAUTION': 'contact_precaution',
  'NPO': 'npo',
  'FOOD_ALLERGY': 'food_allergy',
})
export const PRECAUTIONS = Object.freeze({
  [PRECAUTION_KEYS.FALL_RISK]: 'Fall Risk',
  [PRECAUTION_KEYS.CONTACT_PRECAUTION]: 'Contact Precaution',
  [PRECAUTION_KEYS.NPO]: 'NPO',
  [PRECAUTION_KEYS.FOOD_ALLERGY]: 'Food Allergy',
})

export const PRECAUTIONS_ICONS = Object.freeze({
  [PRECAUTION_KEYS.FALL_RISK]: {
    type: 'svg',
    icon: personFallingIcon
  },
  [PRECAUTION_KEYS.CONTACT_PRECAUTION]: {
    type: 'mdi',
    icon: 'face-mask'
  },
  [PRECAUTION_KEYS.NPO]: {
    type: 'mdi',
    icon: 'food-off'
  },
  [PRECAUTION_KEYS.FOOD_ALLERGY]: {
    type: 'mdi',
    icon: 'allergy'
  },
})

export const PRECAUTIONS_LEVEL = Object.freeze({
  [PRECAUTION_KEYS.FALL_RISK]: { 'high': 'High', 'very_high': 'Very High' },
  [PRECAUTION_KEYS.CONTACT_PRECAUTION]: { 'partial': 'Partial', 'full': 'Full' },
  [PRECAUTION_KEYS.NPO]: { 'on': 'On' },
  [PRECAUTION_KEYS.FOOD_ALLERGY]: { 'low_risk': 'Low Risk', 'high_risk': 'High Risk' }
})

export const VIRTUAL_REQUEST_TYPE_MESSAGES = Object.freeze({
  eicu: 'eICU',
  help: 'Help',
  security: 'Security',
  translator: 'Translation',
  nurse: 'Virtual Nursing',
  scribe: 'Virtual Scribe',
})
